import { useEffect, useState, type FormEvent } from "react";
import { Link, NavLink, useNavigate } from "react-router-dom";

const navItems = [
  { to: "/", label: "首页", end: true },
  { to: "/category/movie", label: "电影", end: false },
  { to: "/category/tv", label: "电视剧", end: false },
  { to: "/search", label: "搜索", end: false },
  { to: "/about", label: "关于", end: false },
];

export default function SiteHeader() {
  const navigate = useNavigate();
  const [keyword, setKeyword] = useState("");
  const [menuOpen, setMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 12);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const handleSearch = (e: FormEvent) => {
    e.preventDefault();
    const q = keyword.trim();
    navigate(q ? `/search?q=${encodeURIComponent(q)}` : "/search");
    setMenuOpen(false);
  };

  return (
    <header
      className={`sticky top-0 z-50 w-full transition-colors duration-300 ${
        scrolled ? "bg-background-50/95 backdrop-blur border-b border-background-200" : "bg-background-50"
      }`}
    >
      <div className="mx-auto flex h-16 items-center gap-4 px-4 md:h-[72px] md:px-8">
        <Link to="/" className="flex shrink-0 items-center gap-2">
          <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-500 text-background-950">
            <i className="ri-movie-2-fill text-xl" aria-hidden="true"></i>
          </span>
          <span className="font-heading text-xl font-700 tracking-wide text-foreground-950 md:text-2xl">西瓜影院</span>
        </Link>

        <nav className="ml-2 hidden items-center gap-1 md:flex">
          {navItems.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              end={item.end}
              className={({ isActive }) =>
                `rounded-md px-3 py-2 text-sm font-500 transition-colors ${
                  isActive
                    ? "bg-primary-500/15 text-primary-400"
                    : "text-foreground-300 hover:bg-background-200 hover:text-foreground-950"
                }`
              }
            >
              {item.label}
            </NavLink>
          ))}
        </nav>

        <form onSubmit={handleSearch} className="ml-auto hidden min-w-0 flex-1 max-w-sm items-center gap-2 md:flex">
          <div className="relative w-full">
            <span className="pointer-events-none absolute left-3 top-1/2 flex h-5 w-5 -translate-y-1/2 items-center justify-center text-foreground-400">
              <i className="ri-search-line text-base" aria-hidden="true"></i>
            </span>
            <input
              value={keyword}
              onChange={(e) => setKeyword(e.target.value)}
              type="text"
              name="keyword"
              placeholder="搜索电影、电视剧、演员…"
              className="h-10 w-full rounded-full border border-background-300 bg-background-100 pl-10 pr-4 text-sm text-foreground-950 outline-none transition-colors placeholder:text-foreground-500 focus:border-primary-500"
            />
          </div>
          <button
            type="submit"
            className="h-10 shrink-0 rounded-full bg-primary-500 px-4 text-sm font-500 text-background-950 transition-colors hover:bg-primary-600"
          >
            搜索
          </button>
        </form>

        <button
          type="button"
          onClick={() => setMenuOpen((v) => !v)}
          aria-label="打开导航菜单"
          className="ml-auto flex h-10 w-10 items-center justify-center rounded-md border border-background-300 text-foreground-950 md:hidden"
        >
          <i className={menuOpen ? "ri-close-line text-xl" : "ri-menu-line text-xl"} aria-hidden="true"></i>
        </button>
      </div>

      {menuOpen && (
        <div className="border-t border-background-200 bg-background-50 px-4 pb-5 pt-4 md:hidden">
          <form onSubmit={handleSearch} className="mb-4 flex items-center gap-2">
            <div className="relative w-full">
              <span className="pointer-events-none absolute left-3 top-1/2 flex h-5 w-5 -translate-y-1/2 items-center justify-center text-foreground-400">
                <i className="ri-search-line text-base" aria-hidden="true"></i>
              </span>
              <input
                value={keyword}
                onChange={(e) => setKeyword(e.target.value)}
                type="text"
                name="keyword"
                placeholder="搜索影片、演员…"
                className="h-11 w-full rounded-full border border-background-300 bg-background-100 pl-10 pr-4 text-sm text-foreground-950 outline-none placeholder:text-foreground-500 focus:border-primary-500"
              />
            </div>
            <button
              type="submit"
              className="h-11 shrink-0 rounded-full bg-primary-500 px-4 text-sm font-500 text-background-950"
            >
              搜索
            </button>
          </form>
          <nav className="flex flex-col gap-1">
            {navItems.map((item) => (
              <NavLink
                key={item.to}
                to={item.to}
                end={item.end}
                onClick={() => setMenuOpen(false)}
                className={({ isActive }) =>
                  `rounded-md px-3 py-3 text-sm font-500 transition-colors ${
                    isActive ? "bg-primary-500/15 text-primary-400" : "text-foreground-200 hover:bg-background-200"
                  }`
                }
              >
                {item.label}
              </NavLink>
            ))}
          </nav>
        </div>
      )}
    </header>
  );
}